module.exports = __webpack_public_path__ + "img/logo.d67828a0.png";